export const INPUT_PADDING = '18px';
